var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line/checkmark-outline",
    clipPath: "url(#clip0_2782_18719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.21607 15.2083H8.21674H8.22507V15.2083L8.22766 15.2082C8.37126 15.2065 8.51294 15.175 8.6438 15.1158C8.77444 15.0568 8.89148 14.9714 8.9876 14.865C8.98776 14.8648 8.98792 14.8647 8.98808 14.8645L16.6002 6.5361C16.6996 6.43753 16.778 6.31993 16.8309 6.19032C16.8846 6.05887 16.9108 5.91783 16.908 5.77587C16.9051 5.63392 16.8733 5.49404 16.8144 5.36484C16.7555 5.23563 16.6709 5.11982 16.5656 5.02453C16.4604 4.92923 16.3368 4.85646 16.2024 4.81068C16.068 4.7649 15.9256 4.74708 15.7841 4.75831C15.6425 4.76954 15.5048 4.8096 15.3793 4.876L15.4767 5.06014L15.3793 4.876C15.2559 4.94131 15.1469 5.03076 15.0587 5.13901L8.20639 12.635L4.92699 9.1407C4.73779 8.93907 4.47624 8.82086 4.19988 8.81207C3.92351 8.80328 3.65498 8.90463 3.45335 9.09384C3.25172 9.28304 3.1335 9.54459 3.12471 9.82095C3.11592 10.0973 3.21728 10.3659 3.40648 10.5675L3.40661 10.5676L7.45565 14.8749C7.45581 14.8751 7.45597 14.8753 7.45612 14.8754C7.55316 14.9799 7.67061 15.0634 7.80121 15.1206C7.93203 15.178 8.07324 15.2078 8.21607 15.2083Z",
    fill: "#0071E9",
    stroke: "#0071E9",
    strokeWidth: 0.416667
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2782_18719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon_checkmark.f9298ec4310ef53550b221784e7d5a0c.svg";
export { ForwardRef as ReactComponent };